import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import ExhibitionInfo from "@/components/ExhibitionInfo";
import ArtistBio from "@/components/ArtistBio";
import Gallery from "@/components/Gallery";
import MereCamara from "@/components/MereCamara";
import JourneySoFar from "@/components/JourneySoFar";
import BlogUpdates from "@/components/BlogUpdates";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";

const Home = () => {
  return (
    <main className="bg-[#0A0A0A] text-[#F5F0E8]">
      <Navigation />
      <Hero />
      <ExhibitionInfo />
      <ArtistBio />
      <Gallery />
      <MereCamara />
      <JourneySoFar />
      <BlogUpdates />
      <Newsletter />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
